/** Invoice line description for a PCR: "{PCR #} {PCR Description}". */
export function buildPcrInvoiceLineDescription(pcrNumber, pcrDescription) {
  const number = String(pcrNumber ?? "").trim();
  const description = String(pcrDescription ?? "").trim();
  if (!number || number === "—") {
    return description;
  }
  if (!description || description === "—") {
    return number;
  }
  return `${number} ${description}`;
}
